(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-bar')) {
    class CountdownBar extends HTMLElement {
      connectedCallback() {
        this.end = this.resolveEnd();
        if (!this.end) return;
        this.values = {
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };
        this.tick();
        this.hidden = this.end <= Date.now();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      resolveEnd() {
        if (this.dataset.mode === 'fixed') {
          const parsed = Date.parse((this.dataset.end || '').replace(' ', 'T'));
          return Number.isNaN(parsed) ? null : parsed;
        }

        const duration = Number(this.dataset.hours || 0) * 3600 * 1000;
        const key = this.dataset.storageKey;
        let stored = 0;
        try {
          stored = Number(window.localStorage.getItem(key)) || 0;
        } catch (error) {
          stored = 0;
        }
        if (stored > Date.now()) return stored;

        const next = Date.now() + duration;
        try {
          window.localStorage.setItem(key, String(next));
        } catch (error) {}
        return next;
      }

      tick() {
        let left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        if (left === 0) {
          if (this.dataset.mode === 'fixed') {
            this.hidden = true;
            window.clearInterval(this.timer);
            return;
          }
          this.end = this.resolveEnd();
          left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        }
        const pad = (value) => String(value).padStart(2, '0');
        this.values.hours.textContent = pad(Math.floor(left / 3600));
        this.values.minutes.textContent = pad(Math.floor(left / 60) % 60);
        this.values.seconds.textContent = pad(left % 60);
      }
    }

    customElements.define('countdown-bar', CountdownBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-wall')) {
    class ReviewsWall extends HTMLElement {
      connectedCallback() {
        const initial = Number(this.dataset.initial || 0);
        const cards = Array.from(this.querySelector('[data-grid]')?.children || []);
        const wrapper = this.querySelector('[data-more-wrapper]');
        if (!initial || cards.length <= initial || !wrapper) return;

        cards.slice(initial).forEach((card) => card.setAttribute('data-collapsed', ''));
        wrapper.hidden = false;
        this.querySelector('[data-more]')?.addEventListener('click', () => {
          cards.forEach((card) => card.removeAttribute('data-collapsed'));
          wrapper.hidden = true;
          cards[initial]?.querySelector('a, button, [tabindex]')?.focus();
        });
      }
    }

    customElements.define('reviews-wall', ReviewsWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-slider')) {
    class TestimonialSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
        this.track.addEventListener('scroll', () => this.sync(), { passive: true });
        this.index = 0;
      }

      get slides() {
        return Array.from(this.track.children);
      }

      go(target) {
        const slides = this.slides;
        if (!slides.length) return;
        const index = (target + slides.length) % slides.length;
        const offset = slides[index].offsetLeft - slides[0].offsetLeft;
        this.track.scrollTo({ left: offset });
        this.setActive(index);
      }

      sync() {
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => {
          const slides = this.slides;
          const start = slides[0]?.offsetLeft || 0;
          let closest = 0;
          let distance = Infinity;
          slides.forEach((slide, i) => {
            const d = Math.abs(slide.offsetLeft - start - this.track.scrollLeft);
            if (d < distance) {
              distance = d;
              closest = i;
            }
          });
          this.setActive(closest);
        });
      }

      setActive(index) {
        this.index = index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
    }

    customElements.define('testimonial-slider', TestimonialSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
